import { AudioMutedOutlined, UsergroupAddOutlined } from "@ant-design/icons";
import { Space, Tooltip } from "antd";
import { StaffSportsCard } from "models/cards";

const CardOwnership = ({ ownersAreSilent, canHaveMultipleOwners }: StaffSportsCard) => {
    if (!ownersAreSilent && !canHaveMultipleOwners) {
        return null;
    }

    return <Space>
        {ownersAreSilent && <Tooltip placement="top" title="Only Silent Accounts">
            <AudioMutedOutlined style={{ color: 'var(--dcs-blue)' }} />
        </Tooltip>}

        {canHaveMultipleOwners && <Tooltip placement="top" title="Allows Multiple Owners">
            <UsergroupAddOutlined style={{ color: 'var(--dcs-blue)' }} />
        </Tooltip>}
    </Space>;
};

export default CardOwnership;